import React from "react";
import PersonalInfo from "./PersonalInfo";

const RightDetails = ({ children, perofileData, setProfileData }) => {
  return (
    <div className="col-xl-9 col-lg-8 wow fadeInUp" data-wow-duration="1s">
      {children?.type?.name === "PersonalInfo" ? (
        <PersonalInfo
          perofileData={perofileData}
          setProfileData={setProfileData}
        />
      ) : (
        children
      )}
    </div>
  );
};

export default RightDetails;
